import type { HTMLAttributes, ReactElement, ReactNode } from 'react';
import { cn } from '@/lib/cn';

export type CardPadding = 'none' | 'sm' | 'md' | 'lg' | 'xl';

const PAD: Readonly<Record<CardPadding, string>> = {
  none: '',
  sm: 'p-3',
  md: 'p-4',
  lg: 'p-6',
  xl: 'p-8',
};

export type CardProps = HTMLAttributes<HTMLDivElement> & {
  padding?: CardPadding;
  hover?: boolean;
  children?: ReactNode;
};

export function Card({
  padding = 'md', hover = false, className, children, ...rest
}: CardProps): ReactElement {
  return (
    <div
      className={cn(
        'bg-[var(--bg-surface)] border border-[var(--rule)] rounded-[var(--r-md)]',
        PAD[padding],
        hover && 'hover:border-[var(--rule-strong)] hover:shadow-[var(--shadow-1)] transition-all cursor-pointer',
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
}
